import { numOrZero } from 'Reports/utils';
import {
  GiftcardReport,
  RawGiftcardReport,
  RawSalesReport,
  SalesReport,
} from './types';

const normalizeSalesReportData = ({
  reportData,
}: {
  reportData: RawSalesReport;
}): SalesReport => {
  const sold = numOrZero(reportData.sold);
  const returned = numOrZero(reportData.returned);

  return {
    ...reportData,
    type: reportData.type || 'product',
    gross_price: numOrZero(reportData.gross_price),
    sold,
    returned,
    total: sold + returned,
    revenue_gross: numOrZero(reportData.revenue_gross),
    revenue_net: numOrZero(reportData.revenue_net),
  };
};

export const normalizeRawSalesReports = (
  rawReports: Array<RawSalesReport>
): Array<SalesReport> =>
  rawReports.map((reportData) => normalizeSalesReportData({ reportData }));

const normalizeGiftcardReportData = ({
  reportData,
}: {
  reportData: RawGiftcardReport;
}): GiftcardReport => ({
  ...reportData,
  redemption: reportData.redemption.map((r) => ({
    ...r,
    redeemed: numOrZero(r.redeemed),
    remaining_value: numOrZero(r.remaining_value),
  })),
  current_value: numOrZero(reportData.current_value),
  amount: numOrZero(reportData.amount),
  tax_rate: numOrZero(reportData.tax_rate),
});

export const normalizeRawGiftcardReports = (
  rawReports: Array<RawGiftcardReport>
): Array<GiftcardReport> =>
  rawReports.map((reportData) => normalizeGiftcardReportData({ reportData }));
